// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"03346f77","504":"c26fcd7d","577":"14b333b1","640":"298b6aaf","851":"3f0086ba"}[chunkId] + ".chunk.js";
};